// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"510":"87f6fae5","787":"eedef71f"}[chunkId] + ".js";
};